<template>
    <div class="promo">
        <div v-if="!showStatus">
            <div v-if="showPromo">
                <div class="d-flex align-items-center">
                    <label>Promo</label>
                    <div class="d-flex ml-auto align-items-center">
                        <input ref="promoInput" class="glued-right" type="text" v-model="promoValue" @keyup.enter="validatePromo">
                        <button class="btn wide ok glued-left" @click="validatePromo">Apply</button>
                    </div>
                </div>
                <div v-if="invalidPromo" class="error mt-1 mb-1">Invalid promo code</div>
            </div>
            <div class="bold" v-else>
                <div @click="openPromo">
                    <i class="ico-ticket color-6 fs-larger"></i>
                    Do you have a promo code?
                </div>
            </div>
        </div>
        <div v-else class="d-flex align-items-center">
            <div class="bold mr-2">{{ promoValue }}</div>
            <i class="ico-check larger success"></i>
            <i class="ico-delete largest" @click="resetPromo"></i>
            <div class="ml-auto">{{ promo.value.toFixed(2)}}€</div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        props: {
            reservation: Object,
            product: Object,
        },
        data: function() {
            return {
                showPromo: false,
                invalidPromo: false,
                promoValue: null,
                showStatus: false,
                promo: null
            }
        },
        created: function() {
            if (this.reservation.billing.promo_id) {
                var vm = this;

                this.showPromo = true;
                var promo = this.product.promos.find(p => {
                    return p.id === vm.reservation.billing.promo_id;
                });
                this.promoValue = promo.token;
                this.validatePromo();
            }
        },
        methods: {
            ...mapActions([
                'addReservationPromo',
                'deleteReservationPromo'
            ]),
            openPromo: function() {
                this.showPromo = !this.showPromo;

                this.$nextTick(function() {
                    this.$refs.promoInput.focus();
                });
            },
            validatePromo: function() {
                if (this.promoValue && this.promoValue.length > 2) {
                    var vm = this;

                    // Convert to lowercase and search for the written promo.
                    // If such promo is found for this product, we must make sure
                    // it's (still) valid

                    this.promo = this.product.promos.find(p => {
                        return p.token.toLowerCase() == vm.promoValue.toLowerCase();
                    });

                    if (this.promo) {
                        var now = moment();

                        // Toggle status check

                        this.showStatus = true;

                        // Can we use this promo code?

                        if (now.isSameOrAfter(this.promo.from) && now.isSameOrBefore(this.promo.until)) {
                            this.applyPromo(this.promo);
                            return;
                        }
                    }
                    this.invalidPromo = true;
                }
            },
            applyPromo: function(promo) {
                this.invalidPromo = false;

                // Apply this promotion to the reservation. This will trigger
                // an update on all related prices automatically (set in the mixin)
                
                this.addReservationPromo(promo.id);
            },
            resetPromo: function() {

                // Remove the promotion from the reservation

                this.deleteReservationPromo();

                // Clear input

                this.promoValue = null;

                // Toggle status check

                this.showStatus = false;
            },
            resetValidation: function() {
                this.invalidPromo = false;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// Promo.vue?0ef0ee44